module.exports = __webpack_public_path__ + "ba6f6ff1c3a53cbd5f856c63efe0ad54.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-21.png
// module id = 2163
// module chunks = 0